import baseWrapperValue from './_baseWrapperValue.js';

/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return baseWrapperValue(this.__wrapped__, this.__actions__);
}

export default wrapperValue;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/wrapperValue.js
// module id = 130
// module chunks = 0